import React from 'react';
import './footer.css';
import contactData from "../../Components/Contact/data";
import addressData from './iconData';
import { HashLink } from 'react-router-hash-link';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-column">
        <div className='columnContent'>
          <h2>Quick Links</h2>
          <ul>
            <HashLink smooth to='/profile' onClick={() => {window.scrollTo(0,0);}}><li>Profile</li></HashLink>
            <HashLink smooth to='/#product' onClick={() => {window.scrollTo(0,0);}}><li>  <li>Product</li></li></HashLink>
            <HashLink smooth to='/cart' onClick={() => {window.scrollTo(0,0);}}><li>Cart</li></HashLink>
            <HashLink smooth to='/order' onClick={() => {window.scrollTo(0,0);}}><li> <li>Order</li></li></HashLink>
            <HashLink smooth to='/#contact' onClick={() => {window.scrollTo(0,0);}}><li>Contact</li></HashLink>
          </ul>
        </div>
      </div>
      <div className="footer-column">
        <div className='columnContent'>
          <h2>Contacts</h2>
          <ul>
            {
              addressData.map((data) => (
                <div className='address'>
                  <i className='icon'>{data.icon}</i>
                  <p className='addressText'>{data.title}</p>
                </div>
              ))
            }
          </ul>
        </div>
      </div>
      <div className="footer-column">
       <div className='columnContent'>
          <h2>Get in Touch</h2>
          <ul className="social-icons">
              {contactData.map((data) => (
                  <div className="social-info-item padd-15" key={data.id}>
                      <a href={data.link} target="_blank" rel="noopener noreferrer">
                          <div className="icon">
                          <i className="fa">{data.icon}</i>
                          </div>
                      </a>
                  </div>
              ))}
          </ul>
       </div>
      </div>
      <div className="footer-bottom">
        <p>Copyright &#9400; 2024 Lahan Traders & Suppliers</p>
      </div>
    </footer>
  );
};

export default Footer;
